import React from 'react';
import { SupplierProfileBuilderPolicies } from './SupplierProfileBuilderPolicies';

interface SupplierProfileBuilderStepPoliciesProps {
  supplierId: string;
  onCountChange?: (count: number) => void;
}

const SupplierProfileBuilderStepPolicies: React.FC<
  SupplierProfileBuilderStepPoliciesProps
> = ({ supplierId, onCountChange }) => {
  return (
    <SupplierProfileBuilderPolicies
      supplierId={supplierId}
      onCountChange={onCountChange}
    />
  );
};

export default SupplierProfileBuilderStepPolicies;
